import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { DataCardShell } from "../../../../components/responsive";
import Helpers from "../../../../components/Helpers";
import { setBrokenImageFallback } from "../../../../utils/imageFallback";
import Profile from "../../../../assets/images/priest-default.png";
import corruptedImg from "../../../../assets/images/corrupted-img.png";
import { priestDisplayName } from "../priestDisplay";

export function PriestCard({
  row,
  isAdmin,
  onEdit,
  onDelete,
}: {
  row: any;
  isAdmin: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
}) {
  return (
    <DataCardShell
      title={
        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            component="img"
            src={row.imageUrl || Profile}
            alt=""
            onError={(e: any) => setBrokenImageFallback(e, corruptedImg)}
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              objectFit: "cover",
              border: "1px solid #e5e7eb",
              flexShrink: 0,
            }}
          />
          <span>{priestDisplayName(row)}</span>
        </Stack>
      }
      subtitle={[
        row.primaryKey ? `ID ${row.primaryKey}` : null,
        row.parish || null,
      ]
        .filter(Boolean)
        .join(" · ")}
      fields={[
        {
          label: "Email",
          value: row.email ? (
            <Typography variant="body2" component="a" href={`mailto:${row.email}`}>
              {row.email}
            </Typography>
          ) : (
            "—"
          ),
        },
        { label: "Address", value: row.address || "—" },
        { label: "City", value: row.city || "—" },
        { label: "State", value: row.state || "—" },
        { label: "Zip", value: row.zip || "—" },
        {
          label: "Created",
          value: row.createdAt
            ? Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")
            : "—",
        },
      ]}
      primaryAction={
        isAdmin ? (
          <Button size="small" variant="contained" onClick={() => onEdit(row)}>
            Edit
          </Button>
        ) : undefined
      }
      secondaryActions={
        isAdmin ? (
          <Button size="small" color="error" variant="outlined" onClick={() => onDelete(row)}>
            Delete
          </Button>
        ) : undefined
      }
    />
  );
}
